module.exports = __webpack_public_path__ + "static/media/myob-logo.34c90591.svg";